/**
 * ページ内リンクかどうかの判定
 * @module 現在のページのファイル名を返す
 * @return {string} - ファイル名
 */
export var getCurrentPagefileName = function () {
    return location.href.match('.+/(.+?)([?#;].*)?$')[1];
};
